import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { getAlignItems, getJustifyContent } from 'hb-builder/utils/attributes';
import { getNetworkColor } from 'hb-builder/utils/colors';

const sectionsType = ['section', 'structure'];

export const getWrapperStyle = ({ attributes, colors, isDragging, style }) => ({
  backgroundColor: getNetworkColor(
    style?.backgroundColor || attributes?.containerBackgroundColor,
    colors,
  ),
  alignItems: getAlignItems(attributes?.verticalAlign),
  justifyContent: getJustifyContent(attributes?.horizontalAlign),
  padding:
    !isDragging && attributes?.containerPadding
      ? attributes?.containerPadding
      : 0,
  width: '100%',
  ...style,
});

const getBorderStyle = ({ theme, $type, $isDragging }) => {
  const borderStyle = $isDragging ? 'none' : `1px dashed ${theme.colors.dove}`;

  return $type === 'section'
    ? `
        border-top: ${borderStyle};
        border-bottom: ${borderStyle};
      `
    : `
        border: 1px solid ${theme.colors.primary};
        outline: 1px solid ${theme.colors.primary};
        border-radius: 2px;
      `;
};

const getLayout = ({ $type }) => css`
  &:after {
    ${getBorderStyle}
    bottom: ${$type === 'single' ? 0 : '-1px'};
    content: ' ';
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: ${$type === 'single' ? 300 : 200};
  }
`;

const getMobileStyle = ({ $paddingOverride }) => css`
  iframe {
    height: 100% !important;
    width: 100% !important;
  }

  ${$paddingOverride && `padding: ${$paddingOverride} !important`};
`;

export const WrapperStyled = styled(Box).attrs(() => ({
  width: '100%',
}))`
  ${({
    $canBeSelected,
    $displayLayout,
    $isDisabled,
    $isDragging,
    $isMobile,
    $isSelected,
    theme,
    $type,
  }) => {
    const pointerEvents =
      sectionsType.includes($type) || $canBeSelected || $isDisabled
        ? 'all'
        : 'none';
    const cursor =
      sectionsType.includes($type) || $isSelected || $isDisabled
        ? 'unset'
        : 'pointer';

    return css`
      cursor: ${cursor};
      margin: 0 auto;
      opacity: ${$isDragging ? 0.6 : undefined};
      pointer-events: ${pointerEvents};
      position: relative;
      z-index: ${$isDragging ? 1 : undefined};

      ${$displayLayout && getLayout({ theme, $type, $isDragging })}

      ${$isMobile && getMobileStyle}
    `;
  }}
`;
